<template>
   <div>
      <div class="form-group _margin-bottom-30">
         <div class="col-xs-12 _margin-bottom-20">
            <form-label id="switchAfterCoolingOfPeriod">Faster Switching</form-label><br />
            <small>Select one:</small>
            <radio :value="false" id="asap" v-model="terms.switchAfterCoolingOfPeriod"
               :error="v.switchAfterCoolingOfPeriod.$error">
               I want to switch to {{ switchPlan.supplierName }} as soon as possible and consent to being billed for the
               services provided after my switch has been processed and pay for any usage of energy consumed should I
               change my mind during the 14 day *cooling off period.
            </radio>

            <radio :value="true" id="14days" v-model="terms.switchAfterCoolingOfPeriod"
               :error="v.switchAfterCoolingOfPeriod.$error">
               Please delay my switch by two weeks until after the 14 day *cooling-off period is over.
            </radio>
         </div>

         <div class="col-xs-12 _margin-bottom-20">
            <small>*The cooling-off period commences the day after you enter a contract with {{ switchPlan.supplierName
               }} for your new energy supply. The cooling off period will last for 14 days. {{ switchPlan.supplierName
               }} will inform you when your new supply for energy will start upon processing this switch</small>
         </div>

         <div class="col-xs-12">
            <form-label id="gasSmartMeterInstalled">Smart Meter</form-label><br />
            <small v-if="switchPlan.fuelTitle == 'Gas & Electricity'">Select at least one:</small>
         </div>

         <div class="col-xs-12"
            :class="{ 'col-sm-4': switchPlan.fuelTitle == 'Gas & Electricity', 'col-sm-6': switchPlan.fuelTitle !== 'Gas & Electricity' }"
            v-if="switchPlan.fuelTitle != 'Electricity'">
            <checkbox id="gasSmartMeterInstalled" v-model="terms.gasSmartMeterInstalled"
               :error="v.neitherSmartMeterInstalled.$error" @change="onChangeSmartMeterInstalled">
               Yes, I have a smart gas meter
            </checkbox>
         </div>

         <div class="col-xs-12"
            :class="{ 'col-sm-5': switchPlan.fuelTitle == 'Gas & Electricity', 'col-sm-6': switchPlan.fuelTitle !== 'Gas & Electricity' }"
            v-if="switchPlan.fuelTitle != 'Gas'">
            <checkbox id="electricitySmartMeterInstalled" v-model="terms.electricitySmartMeterInstalled"
               :error="v.neitherSmartMeterInstalled.$error" @change="onChangeSmartMeterInstalled">
               Yes, I have a smart electricity meter
            </checkbox>
         </div>

         <div class="col-xs-12 col-sm-3" v-if="switchPlan.fuelTitle == 'Gas & Electricity'">
            <checkbox id="neitherSmartMeterInstalled" v-model="terms.neitherSmartMeterInstalled"
               :error="v.neitherSmartMeterInstalled.$error" @change="onChangeNeitherInstalled">
               Neither
            </checkbox>
         </div>
      </div>
      <div class="form-group _margin-bottom-20" v-show="switchPlan.payMethod == 'PrePaymentMeter'">
         <div class="col-sm-8">
            <form-label id="prePaymentMeter">Pre Payment Meter Type</form-label>
            <validation-messages label="Pre Payment Meter Type" :$v="v.prePaymentMeterId">
               <select-list id="prePaymentMeter" v-model="terms.prePaymentMeterId" value-key="id" :list="prepaymentList"
                  :error="v.prePaymentMeterId.$error" />
            </validation-messages>
         </div>
      </div>
      <uiv-alert type="info" v-if="terms.gasSmartMeterInstalled || terms.electricitySmartMeterInstalled">
         <div class="_margin-bottom-10">
            <b>If you have a smart meter you may lose some or all of its SMART functionality .e.g.</b>
         </div>

         - Automated meter reading<br />
         - Energy display or monitor
      </uiv-alert>

      <div class="form-group" v-if="terms.gasSmartMeterInstalled || terms.electricitySmartMeterInstalled">
         <div class="col-md-10">
            <validation-messages label="Agreement" :$v="v.agreeSmartMeterConditions">
               <checkbox id="agreeSmartMeterConditions" v-model="terms.agreeSmartMeterConditions"
                  :error="v.agreeSmartMeterConditions.$error"
                  @change="terms.agreeSmartMeterConditions = terms.agreeSmartMeterConditions ? true : null">
                  Yes, I can confirm that I understand the loss of this functionality
                  and am happy to continue.
               </checkbox>
            </validation-messages>
         </div>
      </div>

      <uiv-alert type="danger" v-if="v.agreeSmartMeterConditions.$error">
         <b>Smart Meter Terms & Conditions</b><br />

         As you have not agreed {{ switchPlan.supplierName }}'s smart meter terms
         and conditions, this switch cannot proceed. However, you can still switch
         to other supplier from results page by pressing back button.
      </uiv-alert>


      <div class="form-group _margin-bottom-30">
         <div class="col-md-10">
            <form-label id="supplierMaySendUpdatesThatMayBeOfInterestViaMobilePhone">
               <b>Don't miss out on the best bits</b><br /><br />
               Incredible prize draws, exciting partnerships and offers from British Gas and related brands like Hive and Dyno – there are always new things to share. Just tell British Gas how you’d like to hear about them.
            </form-label>
            <br />
            <small>
               Settings can be changed anytime over Live Chat and customers can find out more in the
               <a href="https://www.britishgas.co.uk/legal-compliance/privacy-policy.html" target="_blank">Privacy notices - British Gas</a>.
               British Gas will always keep customers updated about their account no matter what.
            </small>
            <br />
            <br />
            <small><b>Choose how to stay in touch</b></small>

            <div class="row">
               <div class="col-xs-6 col-sm-3">
                  <checkbox id="supplierMaySendUpdatesThatMayBeOfInterestViaEmail"
                     v-model="terms.supplierMaySendUpdatesThatMayBeOfInterestViaEmail">
                     Email
                  </checkbox>
               </div>

               <div class="col-xs-6 col-sm-3">
                  <checkbox id="supplierMaySendUpdatesThatMayBeOfInterestViaSms"
                     v-model="terms.supplierMaySendUpdatesThatMayBeOfInterestViaSms">
                     Text (including WhatsApp)
                  </checkbox>
               </div>

               <div class="col-xs-6 col-sm-3">
                  <checkbox id="supplierMaySendUpdatesThatMayBeOfInterestViaMobilePhone"
                     v-model="terms.supplierMaySendUpdatesThatMayBeOfInterestViaMobilePhone">
                     Phone
                  </checkbox>
               </div>

               <div class="col-xs-6 col-sm-3">
                  <checkbox id="supplierMaySendUpdatesThatMayBeOfInterestViaPost"
                     v-model="terms.supplierMaySendUpdatesThatMayBeOfInterestViaPost">
                     Post
                  </checkbox>
               </div>
            </div>
         </div>
      </div>

      <div class="form-group _margin-bottom-20">
         <div class="col-sm-12">
            <checkbox id="hasMedicalCondition" v-model="terms.hasMedicalConditionOrIndividualRequirement"
               @change="onChangeSpecialNeeds">
               I have a particular medical condition or individual requirement.<br />
               <small v-if="terms.hasMedicalConditionOrIndividualRequirement">Any information provided will be passed
                  onto your new Supplier, who may subsequently request further information from you.</small>
            </checkbox>
         </div>

         <div class="col-sm-8 _margin-top-20" v-if="terms.hasMedicalConditionOrIndividualRequirement">
            <form-label id="condition">Conditions</form-label>
            <validation-messages label="Condition" :$v="v.specialNeedsId">
               <select-list id="condition" v-model="terms.specialNeedsId" value-key="id" :list="specialNeedsList"
                  :error="v.specialNeedsId.$error" />
            </validation-messages>
         </div>
      </div>

      <div class="form-group _margin-bottom-20">
         <div class="col-md-10">
            <validation-messages label="Terms & Conditions Agreement" :$v="v.suppliersTermsAndConditionsAreAccepted">
               <checkbox id="termsAndConditions" v-model="terms.suppliersTermsAndConditionsAreAccepted"
                  :error="v.suppliersTermsAndConditionsAreAccepted.$error"
                  @change="terms.suppliersTermsAndConditionsAreAccepted = terms.suppliersTermsAndConditionsAreAccepted ? true : null">
                  Yes, I accept the energy supplier
                  <a target="_blank" :href="switchPlan.supplierTosUrl">terms and conditions</a>
               </checkbox>
            </validation-messages>
         </div>
      </div>
   </div>
</template>

<script>
/**
 * British Gas supplier consents (supplierId === 2).
 *
 * Single shared component: all acquisition white-labels that use
 * `apps/base/components/supplier-specific-terms` (e.g. Home, Tenantshop,
 * Switch Genius, RADDAF, Purple Bricks, Perks Direct, Moody Moose, BCS,
 * Switch 4 Good, My Utility Genius / MUG PCW, Energy Dundee 4-U, etc.)
 * render this file — no per-app copy. Rebuild each deployed app to pick up changes.
 */
import { mapState } from 'vuex';

export default {
   name: 'BritishGas',
   props: {
      v: Object
   },
   computed: {
      ...mapState({
         switchPlan: ({ personal_details_switch_plan }) => personal_details_switch_plan,
         terms: ({ personal_details_terms }) => personal_details_terms,
         specialNeedsList: ({ lookups }) => lookups.specialNeeds,
         prepaymentList: ({ lookups }) => lookups.prepayments
      })
   },
   methods: {
      onChangeSpecialNeeds() {
         if (this.terms.hasMedicalConditionOrIndividualRequirement) {
            this.$store.dispatch('lookups/getSpecialNeedsList');
         } else {
            this.terms.specialNeedsId = null;
         }
      },
      onChangeSmartMeterInstalled() {
         if (this.terms.gasSmartMeterInstalled || this.terms.electricitySmartMeterInstalled) {
            this.terms.agreeSmartMeterConditions = null;
            this.terms.neitherSmartMeterInstalled = false;
         } else {
            this.terms.agreeSmartMeterConditions = false;
            this.terms.neitherSmartMeterInstalled = null;
         }
      },
      onChangeNeitherInstalled(value) {
         this.terms.neitherSmartMeterInstalled = value || null;
         this.terms.gasSmartMeterInstalled = false;
         this.terms.electricitySmartMeterInstalled = false;
         this.terms.agreeSmartMeterConditions = false;
      }
   }
};
</script>

<style lang="scss"></style>
